import { SVGProps, Ref, forwardRef } from 'react';

export const PenOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 15.5h4.14L14.642 5.497a2.927 2.927 0 1 0-4.14-4.14L.5 11.361zm11.084-8.925L4.059 14.1H1.9v-2.16l7.525-7.524zm.99-.99 1.079-1.078a1.527 1.527 0 0 0-2.16-2.16l-1.078 1.08z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PenOutlinedSize16Glyph.displayName = 'PenOutlinedSize16Glyph';
